import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import EventTablesLayer from '../components/EventTablesLayer';

const EventTablesPage = () => (
  <MasterLayout pageTitle='Event Reference Tables'>
    <EventTablesLayer />
  </MasterLayout>
);

export default EventTablesPage;
